import { useEffect, useRef, useState } from "react";
import { isAudioActive } from "../../lib/speech";

const WAKE_RX = /hey\s*force|hey[,\s]+forrest|a\s*force/i;

// Shared "Hey FORCE" always-listening hook (browser SpeechRecognition — free,
// no keys). Pauses while `busy` (overlay open / app speaking), auto-restarts.
export function useWakePhrase(enabled, busy, onWake) {
    const [listening, setListening] = useState(false);
    const cooldownRef = useRef(0);

    useEffect(() => {
        if (!enabled || busy) { setListening(false); return; }
        const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SR) { setListening(false); return; }
        let dead = false;
        const rec = new SR();
        rec.continuous = true;
        rec.interimResults = true;
        rec.lang = "en-US";
        rec.onresult = (e) => {
            if (Date.now() < cooldownRef.current) return;
            try {
                if (isAudioActive()) return; // don't hear ourselves (TTS or robot video)
            } catch { /* noop */ }
            for (let i = e.resultIndex; i < e.results.length; i++) {
                if (WAKE_RX.test(e.results[i][0].transcript || "")) {
                    cooldownRef.current = Date.now() + 4000;
                    dead = true;
                    try { rec.stop(); } catch { /* noop */ }
                    onWake();
                    break;
                }
            }
        };
        rec.onend = () => { if (!dead) { try { rec.start(); } catch { /* noop */ } } };
        rec.onerror = () => { /* onend restarts */ };
        try { rec.start(); setListening(true); } catch { setListening(false); }
        return () => {
            dead = true;
            try { rec.stop(); } catch { /* noop */ }
            setListening(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, busy]);

    return listening;
}
